export const SignupRefKey = 'v2_signup_ref';
